import { atom } from 'recoil';

export const filterState = atom({
  key: 'filterState', // unique ID (with respect to other atoms/selectors)
  default: {
    dokumentaDatumsFrom: '',
    dokumentaDatumsTo: '',
    tiesa: '',
    tiesasInstance: '', // <-- Added this line for court instance filter
    likumaAtsauces: [
      {
        likumaAtsauceStart: '',
        likumaAtsauceEnd: '',
        likumaAtsauceSlider: [0, 100],
      },
    ],
  }, // default value (initial state)
});